import { motion } from "framer-motion";

const items = [
  { name: "PAN BIMBO GRANDE", qty: 1, price: 62.0 },
  { name: "COCA COLA MEDIANA", qty: 1, price: 22.0 },
  { name: "AZÚCAR 1 KG", qty: 1, price: 34.5 },
  { name: "FRIJOL 0.5 KG", qty: 1, price: 28.0 },
];

const subtotal = items.reduce((s, i) => s + i.price, 0);
const iva = subtotal * 0.16;
const total = subtotal + iva;

export default function Ticket() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30, rotate: -2 }}
      whileInView={{ opacity: 1, y: 0, rotate: -2 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className="ticket-card w-[280px] md:w-[320px] font-mono"
      data-testid="ticket"
      style={{ transform: "rotate(-2deg)" }}
    >
      <div className="ticket-tear" />
      <div className="px-6 pt-4 pb-6">
        <div className="text-center pb-3 border-b border-dashed border-black/20">
          <p className="text-[10px] tracking-[0.3em] text-black/60">TIENDA DOÑA MARU</p>
          <p className="font-display text-2xl tracking-tighter">CHALANN POS</p>
          <p className="text-[10px] text-black/50 mt-1">
            {new Date().toLocaleDateString("es-MX", { day: "2-digit", month: "long", year: "numeric" })} · 09:41
          </p>
        </div>

        <div className="pt-4 space-y-1.5 text-[13px]">
          {items.map((it, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.15 * idx + 0.3, duration: 0.5 }}
              className="flex justify-between"
            >
              <span className="truncate pr-2">{it.name}</span>
              <span>${it.price.toFixed(2)}</span>
            </motion.div>
          ))}
        </div>

        <div className="mt-4 pt-3 border-t border-dashed border-black/20 space-y-1 text-[12px]">
          <div className="flex justify-between text-black/70">
            <span>Subtotal</span><span>${subtotal.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-black/70">
            <span>IVA 16%</span><span>${iva.toFixed(2)}</span>
          </div>
          <div className="flex justify-between font-black text-lg pt-2">
            <span>TOTAL</span><span>${total.toFixed(2)}</span>
          </div>
        </div>

        <div className="text-center mt-4 pt-3 border-t border-dashed border-black/20">
          <p className="text-[10px] tracking-[0.25em] text-black/60">GRACIAS · VUELVA PRONTO</p>
          <div className="mt-2 flex justify-center">
            <div className="flex gap-[2px]">
              {Array.from({ length: 30 }).map((_, i) => (
                <span
                  key={i}
                  className="block bg-black"
                  style={{
                    width: i % 3 === 0 ? 2 : 1,
                    height: 22,
                  }}
                />
              ))}
            </div>
          </div>
          <p className="text-[9px] font-mono mt-1 text-black/60">CHLN-0000-4218</p>
        </div>
      </div>
      <div className="ticket-tear" />
    </motion.div>
  );
}
